import TimelineIcon from '@mui/icons-material/Timeline';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import Page from 'modules/Page';
import * as constants from './constants';

const ProjectsPage = lazyWithSuspense(() => import('./ProjectsPage'));

const page: Page = {
  title: constants.TITLE,
  mainMenuConfig: {
    iconComponent: TimelineIcon,
  },
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: makePage({ WrappedPage: ProjectsPage, titleFn: () => i18n._(constants.TITLE) }),
};

export default page;
